import script from "./VControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./VControl.vue?vue&type=script&setup=true&lang=ts"

import "./VControl.vue?vue&type=style&index=0&id=61d0f824&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d0f824"]])

export default __exports__